/* 
 *  Created by SGiri 02/14/2018
 */

import { Component, OnDestroy, ViewContainerRef, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { ShellService, KeybindService } from '~core/services';
import { CommonService } from './util/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { LeftMenuItem } from './navbar/NavItem';
import { BI_HttpService } from './services/http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {
  windowListeners: { listener: EventListener, eventName: string }[] = [];

  isActive: boolean;
  currentMenu: string;
  @ViewChild('appRootElement') appRootElement: ElementRef;
  navItems: Observable<LeftMenuItem[]>;

  constructor(vcr: ViewContainerRef,
    shell: ShellService,
    keybindService: KeybindService,
    private commonService: CommonService,
    private router: Router,
    private renderer: Renderer2,
    private http: BI_HttpService) {

    if (window) {
      this.windowListeners.push({
        eventName: 'keydown',
        listener: ev => keybindService.emitKeypress(ev as KeyboardEvent)
      });

      this.windowListeners.forEach(ev => window.addEventListener(ev.eventName, ev.listener));
    }

    shell.setRootElement(vcr);

    this.commonService.isActive.subscribe(value => {
      this.isActive = value;
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentMenu = event.urlAfterRedirects.replace('/', '');
      }
    })

    this.navItems = <Observable<LeftMenuItem[]>>this.http.getAssets('leftNav.json');
  }

  ngOnDestroy() {
    if (window) {
      this.windowListeners
        .forEach(listener => window.removeEventListener(listener.eventName, listener.listener));

      this.windowListeners = [];
    }
  }

  appButtonClicked(event) {
    if (event) {
      this.appRootElement.nativeElement.classList.add('resize');
      this.renderer.addClass(document.body, 'raul-left-navigation-expanded');
    } else {
      this.appRootElement.nativeElement.classList.remove('resize');
      this.renderer.removeClass(document.body, 'raul-left-navigation-expanded');
    }
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/app.component.ts